<template>
   <div
      id="call-me-modal"
      class="modal fade"
      tabindex="-1"
      aria-labelledby="call-me-modal"
      aria-hidden="true">
      <div class="modal-dialog modal-sm modal-dialog-centered modal-dialog-scrollable">
         <div class="modal-content">
            <div class="modal-header">
               <h5 class="modal-title">
                  Ring til os
               </h5>
               <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close" />
            </div>
            <div class="modal-body">
               <div v-if="submitted">
                  <p>Hej {{ form.name }}</p>
                  <p>Vi har modtaget din forespørgsel. Du vil blive kontaktet hurtigst muligt.</p>
               </div>
               <div v-else>
                  <p>
                     Vores kundeservice har åbent alle hverdage i tidsummet <strong>09.00 - 16.00</strong> på tlf.: <strong><a
                        href="tel:86518000"
                        class="phone-link">8651 8000</a></strong>.
                  </p>
                  <p>Du kan også efterlade dit navn og telefon-nummer, så ringer vi dig op hurtigst muligt.</p>
                  <form
                     ref="call-me-form"
                     :class="{'was-validated': validate}"
                     @submit.prevent="submit"
                     @reset="reset">
                     <div class="form-group">
                        <label for="name">Navn</label>
                        <input
                           id="name"
                           v-model="form.name"
                           type="text"
                           class="form-control"
                           required>
                        <div class="invalid-feedback">
                           Navn mangler
                        </div>
                     </div>
                     <div class="form-group">
                        <label for="phone">Telefonnummer</label>
                        <input
                           id="phone"
                           v-model="form.phone"
                           type="text"
                           class="form-control"
                           pattern="\d{8}"
                           required>
                        <div class="invalid-feedback">
                           Telefonnummer mangler
                        </div>
                     </div>
                  </form>
               </div>
            </div>
            <div class="modal-footer">
               <button
                  type="button"
                  class="btn btn-outline-secondary"
                  data-bs-dismiss="modal">
                  Luk
               </button>
               <button
                  v-if="!submitted"
                  type="button"
                  class="btn btn-primary"
                  @click.prevent="submit">
                  Ja tak, ring mig op
               </button>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
export default {
   name: 'CallMeModal',
   data() {
      return {
         show: false,
         validate: false,
         submitted: false,
         form: {
            name: '',
            phone: '',
         },
      };
   },
   methods: {
      submit(e) {
         e.preventDefault();
         e.stopPropagation();
         this.validate = true;
         const form = this.$refs['call-me-form'];
         if (!form.checkValidity()) {
            return;
         }
         window.axios.post('/wp-content/themes/findforsikring_2015-sommer/code/contact_me.php', {
            userName: this.form.name,
            userPhone: this.form.phone,
         }, {
            headers: {
               'Content-Type': 'application/json',
            },
         }).then(({ data }) => {
            this.submitted = true;
         });
      },
      reset() {
         this.validate = false;
         this.form.name = '';
         this.form.phone = '';
      },
   },
};
</script>

<style lang="scss" scoped>
@import "~/colors";
p {
    font-size: 14px;
    margin-bottom: 10px;
}
.form-group{
    margin-bottom: .5rem;
}
label {
    font-weight: bold;
    margin-bottom: .1rem;
}

h5 {
    //font-family: 'Amaranth', sans-serif;
    font-weight: bold;
    margin: 0;
    font-size: 18px;
}
.phone-link{
    color: $ff-dark-blue;
}
</style>
